import { CargoType } from '../../../../../../_metronic/helpers'
import { createListFilters, IOption } from '../../../../../components'

export type FuncionariosFilters = {
  /** Nome do funcionário (busca parcial). */
  nome: string
  empresa?: IOption<number>
  cargo?: IOption<CargoType>
  status?: IOption<boolean>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<FuncionariosFilters>({
  nome: '',
  empresa: undefined,
  cargo: undefined,
  status: undefined,
})
